import CtaSection from './components/CtaSection';
import FeaturesSection from './components/FeaturesSection';
import HeroSection from './components/HeroSection';
import HighlightSection from './components/HighlightSection';
import HowItWorks from './components/HowItWorks';
import PrivacyPage from './components/PrivacyPage';
import SiteFooter from './components/SiteFooter';
import SiteHeader from './components/SiteHeader';
import TermsPage from './components/TermsPage';
import './App.css';

function App() {
  if (window.location.pathname === '/privacy') {
    return <PrivacyPage />;
  }

  if (window.location.pathname === '/terms') {
    return <TermsPage />;
  }

  return (
    <main className="page-shell">
      <SiteHeader />
      <HeroSection />
      <HowItWorks />
      <FeaturesSection />
      <HighlightSection />
      <CtaSection />
      <SiteFooter />
    </main>
  );
}

export default App;
